import TentangSampah from '../views/pages/tentang-sampah-page';
import LandingPage from '../views/pages/landing-page';
import About from '../views/pages/about-page';

const routes = {
  '/': LandingPage,
  '/tentang-sampah': TentangSampah,
  '/kami': About,
};

export default routes;
